"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToggler = useToggler;
var _react = require("react");
function useToggler(initial = false) {
  const _useState = (0, _react.useState)(initial),
    isToggled = _useState[0],
    setIsToggled = _useState[1];
  const toggleOn = (0, _react.useCallback)(() => {
    setIsToggled(true);
  }, [setIsToggled]);
  const toggleOff = (0, _react.useCallback)(() => {
    setIsToggled(false);
  }, [setIsToggled]);
  const toggle = (0, _react.useCallback)(() => {
    setIsToggled(prev => !prev);
  }, [setIsToggled]);
  const toggler = (0, _react.useMemo)(() => {
    return {
      toggleOn,
      toggleOff,
      toggle
    };
  }, [toggleOn, toggleOff, toggle]);
  return [isToggled, toggler];
}